import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './MoreDropdown.css';

const MoreDropdown = ({ isOpen, onClose, dropdownRef }) => {

 

  

 

  return (
    <>
      <div className="more-dropdown-overlay" onClick={onClose} aria-hidden="true"></div>
      <div ref={dropdownRef} className="more-dropdown" role="dialog" aria-label="More Menu">
        <div className="more-dropdown-container">
          
          {/* News Column */}
          <div className="more-column">
            <h3 className="more-column-title">News</h3>
            <nav aria-label="News Navigation">
              <ul className="more-menu-list">
                <li><Link to="/markets" className="more-menu-item" onClick={onClose}>Markets</Link></li>
                <li><Link to="/economics" className="more-menu-item" onClick={onClose}>Economics</Link></li>
                <li><Link to="/industries" className="more-menu-item" onClick={onClose}>Industries</Link></li>
                <li><Link to="/tech" className="more-menu-item" onClick={onClose}>Technology</Link></li>
                <li><Link to="/article/ai-revolution-transforms-industries" className="more-menu-item" onClick={onClose}>AI</Link></li>
                <li><Link to="/politics" className="more-menu-item" onClick={onClose}>Politics</Link></li>
                <li><Link to="/article/renewable-energy-investment-high" className="more-menu-item" onClick={onClose}>Green</Link></li>
                <li><Link to="/article/bitcoin-holds-100k" className="more-menu-item" onClick={onClose}>Crypto</Link></li>
              </ul>
            </nav>
          </div>

          {/* Work & Life Column */}
          <div className="more-column">
            <h3 className="more-column-title">Work & Life</h3>
            <nav aria-label="Work & Life Navigation">
              <ul className="more-menu-list">
                <li><Link to="/wealth" className="more-menu-item" onClick={onClose}>Wealth</Link></li>
                <li><Link to="/pursuits" className="more-menu-item" onClick={onClose}>Pursuits</Link></li>
                <li><Link to="/businessweek" className="more-menu-item" onClick={onClose}>Businessweek</Link></li>
                <li><Link to="/citylab" className="more-menu-item" onClick={onClose}>CityLab</Link></li>
                <li><Link to="/sports" className="more-menu-item" onClick={onClose}>Sports</Link></li>
                <li><Link to="/equality" className="more-menu-item" onClick={onClose}>Equality</Link></li>
                <li><Link to="/management-work" className="more-menu-item" onClick={onClose}>Management & Work</Link></li>
              </ul>
            </nav>
          </div>

          {/* Media Column */}
          <div className="more-column">
            <h3 className="more-column-title">Media</h3>
            <nav aria-label="Media Navigation">
              <ul className="more-menu-list">
                <li><a href="/originals" className="more-menu-item">Originals</a></li>
                <li><a href="/redbox-tv" className="more-menu-item">RedBox TV+</a></li>
                <li><a href="/podcasts" className="more-menu-item">Podcasts</a></li>
                <li><a href="/radio" className="more-menu-item">Radio</a></li>
                <li><a href="/live-events" className="more-menu-item">Live Events</a></li>
                <li><a href="/live-qa" className="more-menu-item">Live Q&A</a></li>
              </ul>
            </nav>
          </div>

          {/* Explore Column */}
          <div className="more-column">
            <h3 className="more-column-title">Explore</h3>
            <nav aria-label="Explore Navigation">
              <ul className="more-menu-list">
                <li><a href="/newsletters" className="more-menu-item">Newsletters</a></li>
                <li><a href="/weekend" className="more-menu-item">Weekend</a></li>
                <li><a href="/graphics" className="more-menu-item">Graphics</a></li>
                <li><a href="/investigations" className="more-menu-item">Investigations</a></li>
                <li><a href="/the-big-take" className="more-menu-item">The Big Take</a></li>
                <li><a href="/explainers" className="more-menu-item">Explainers</a></li>
                <li><a href="/news-quiz" className="more-menu-item">Pointed News Quiz</a></li>
                <li>
                  <a href="/alphadots" className="more-menu-item">
                    Alphadots Game <span className="new-badge">NEW</span>
                  </a>
                </li>
                <li><a href="/markets-magazine" className="more-menu-item">Markets Magazine</a></li>
              </ul>
            </nav>
          </div>

          {/* Tools Column */}
          <div className="more-column">
            <h3 className="more-column-title">Tools</h3>
            <nav aria-label="Tools Navigation">
              <ul className="more-menu-list">
                <li><a href="/watchlist" className="more-menu-item">Watchlist</a></li>
                <li><a href="/submit-tip" className="more-menu-item">Submit a Tip</a></li>
                <li><a href="/help" className="more-menu-item">Help Center</a></li>
                <li><a href="/about-us" className="more-menu-item">About Us</a></li>
              </ul>
            </nav>
          </div>

          {/* Sponsored Content Column */}
          <div className="more-column">
            <h3 className="more-column-title">Sponsored Content</h3>
            <nav aria-label="Sponsored Content Navigation">
              <ul className="more-menu-list">
                <li><a href="/media-studios" className="more-menu-item">RedBox Global Media Studios</a></li>
                <li><a href="/youtube" className="more-menu-item">RBG YouTube</a></li>
              </ul>
            </nav>
          </div>

        </div>
      </div>
    </>
  );
};

export default MoreDropdown;
